export enum RequestSourceType {
	PREVIEW = 'preview',
	DASHBOARD = 'dashboard',
	PREVIEWAUTO = 'previewAutomatic'
}
